import * as v from 'valibot';
import { integerInRange } from '../../util/valibot';
export const groupSchema = v.object({
    id: integerInRange(0, 0xffff),
    name: v.string(),
});
